/* ============================================================
   ALMAC SPORTS — CHATBOT + EXIT POPUP LOGIC
   Version 2.0 — Full rewrite
   
   FIXES vs v1:
   - Proactive bubble .show CSS was missing — now works
   - Typing dots (.ac-dot) now actually animate
   - sendToSheet() fired twice — now intentional 2-step capture:
       Step 1 (phone only)  → saves lead even if user drops
       Step 2 (phone+name)  → enriches the record
   - Service WhatsApp message now correctly says "service request"
   - "Service/Support" button on product pages now routes correctly
   - iFIT objection path added
   - Recommendation flow now shows actual model suggestions
   - Funnel shortened — contact offer by step 2 max
   - Exit popup blocked if chatbot already engaged
   - Orange accent replaced with #1E86FF (matches site theme)
   - Header text fixed on non-product pages
   ============================================================ */

(function () {

  /* ============================================================
     UTILS
     ============================================================ */
  function getShopifyContext() {
    let product = null;
    try {
      if (typeof meta === 'object' && meta.product) {
        const t = meta.product.name || meta.product.title || meta.product.variants?.[0]?.name;
        if (t) product = { title: t };
      }
      if (!product && (document.body.classList.contains('product-template') || document.body.id === 'product')) {
        product = { title: document.title.split('–')[0].split('|')[0].trim() };
      }
    } catch (e) {}
    return { product };
  }

  function getUTM() {
    const p = new URLSearchParams(window.location.search);
    const ref = document.referrer ? (new URL(document.referrer).hostname || 'Direct') : 'Direct';
    return {
      source:   p.get('utm_source')   || ref,
      medium:   p.get('utm_medium')   || 'Unknown',
      campaign: p.get('utm_campaign') || 'Not Set',
    };
  }

  function isCollectionPage() {
    return (
      document.body.classList.contains('template-collection') ||
      window.location.href.includes('/collections/')
    );
  }

  function collectionName() {
    const slug = window.location.pathname.split('/').filter(Boolean).pop() || '';
    return slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  /* ============================================================
     PRODUCT RECOMMENDATIONS BY BUDGET
     ============================================================ */
  const RECO = {
    Treadmill: {
      '₹1L – ₹2L':   { model: 'Runow R30',                    note: 'Best entry-level treadmill — solid motor, reliable build for daily home use.' },
      '₹2L – ₹3.5L': { model: 'NordicTrack Commercial 1250 / 1750', note: 'Premium home treadmills with iFIT integration and Auto-Adjust incline.' },
      '₹3.5L+':       { model: 'NordicTrack Commercial 2450 / X24',  note: 'Flagship commercial-grade machines with rotating 24" iFIT touchscreen.' },
    },
    'Exercise Bike': {
      '₹1L – ₹2L':   { model: 'Runow Exercise Bike',           note: 'Quiet belt-drive bike for daily cardio — smooth ride at home.' },
      '₹2L – ₹3.5L': { model: 'NordicTrack GX Series Bike',    note: 'iFIT-enabled upright bike with HD screen and Auto-Adjust resistance.' },
      '₹3.5L+':       { model: 'NordicTrack X24 Spin Bike',     note: '360° rotating 24" iFIT screen, studio-grade spin for home.' },
    },
    Elliptical: {
      '₹1L – ₹2L':   { model: 'Entry Elliptical',              note: 'Low-impact cardio for home — easy on joints, full-body workout.' },
      '₹2L – ₹3.5L': { model: 'NordicTrack Elliptical SE Series', note: 'iFIT-enabled elliptical with adjustable stride and incline.' },
      '₹3.5L+':       { model: 'NordicTrack Airglide 16',       note: '16" adjustable stride, iFIT Auto-Adjust — mimics real outdoor movement.' },
    },
    'Rowing Machine': {
      '₹1L – ₹2L':   { model: 'Entry Rower',                   note: 'Magnetic resistance rower — full-body, low-impact cardio.' },
      '₹2L – ₹3.5L': { model: 'NordicTrack RW600',             note: 'Silent magnetic resistance with iFIT and pivoting 10" screen.' },
      '₹3.5L+':       { model: 'NordicTrack RW900',             note: '22" pivoting HD touchscreen, iFIT scenic rows with Auto-Adjust resistance.' },
    },
  };

  /* ============================================================
     PRODUCT SPECS — key specs per model for quick answers
     ============================================================ */
  const SPECS = {
    'NordicTrack Commercial 2450': {
      screen:   '24" HD Rotating Touchscreen',
      motor:    '4.25 CHP Commercial Motor',
      incline:  '-3% Decline to 12% Incline',
      speed:    'Up to 20 km/h',
      ifit:     'Yes — Auto-Adjust speed & incline',
      warranty: '10yr Frame | 1yr Parts | 1yr Labour',
    },
    'NordicTrack X24': {
      screen:   '24" HD Rotating Touchscreen (180°)',
      motor:    '4.25 CHP Commercial Motor',
      incline:  '-6% Decline to 40% Incline',
      speed:    'Up to 20 km/h',
      ifit:     'Yes — Auto-Adjust speed & incline',
      warranty: '10yr Frame | 1yr Parts | 1yr Labour',
    },
    'NordicTrack Commercial 1750': {
      screen:   '16" HD Touchscreen',
      motor:    '4.25 CHP Commercial Motor',
      incline:  '-3% Decline to 12% Incline',
      speed:    'Up to 22 km/h',
      ifit:     'Yes — Auto-Adjust speed & incline',
      warranty: '10yr Frame | 1yr Parts | 1yr Labour',
    },
    'NordicTrack Commercial 1250': {
      screen:   '10" HD Touchscreen',
      motor:    '3.6 CHP Motor',
      incline:  '-3% Decline to 12% Incline',
      speed:    'Up to 20 km/h',
      ifit:     'Yes — Auto-Adjust speed & incline',
      warranty: '10yr Frame | 1yr Parts | 1yr Labour',
    },
    'NordicTrack Airglide 16': {
      stride:   '16" Adjustable Stride',
      resistance: '26 Digital Resistance Levels',
      screen:   '16" HD Touchscreen',
      ifit:     'Yes — Auto-Adjust resistance & incline',
      warranty: '10yr Frame | 1yr Parts | 1yr Labour',
    },
    'NordicTrack RW900': {
      screen:   '24" HD Pivoting Touchscreen',
      resistance: 'Silent Magnetic Resistance (26 levels)',
      ifit:     'Yes — Auto-Adjust resistance',
      warranty: '10yr Frame | 2yr Parts | 1yr Labour',
    },
  };

  function getSpecs(productTitle) {
    if (!productTitle) return null;
    const key = Object.keys(SPECS).find(k =>
      productTitle.toLowerCase().includes(k.toLowerCase())
    );
    return key ? SPECS[key] : null;
  }
  const shopify    = getShopifyContext();
  const utm        = getUTM();
  const isMobile   = window.innerWidth <= 768;
  const PRODUCT    = shopify.product?.title || null;
  const WEBHOOK    = 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTZiMDYzMzA0Mzc1MjY0NTUzZDUxMzEi_pc';

  let chatOpened   = false;
  let chatEngaged  = false; // true once user taps a button or sends a message
  let step         = '';    // tracks current conversation node

  const lead = {
    name:     '',
    phone:    '',
    category: '',
    purpose:  '',
    budget:   '',
  };

  /* ============================================================
     BUILD DOM
     ============================================================ */

  // — Launcher —
  const launcher = document.createElement('div');
  launcher.id    = 'almac-chatbot-launcher';
  launcher.innerHTML = `
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
    </svg>
    <span class="ac-badge">1</span>`;
  document.body.appendChild(launcher);

  // — Proactive Bubble —
  const proactive = document.createElement('div');
  proactive.id    = 'almac-chatbot-proactive';
  document.body.appendChild(proactive);

  // — Chat Window —
  const win  = document.createElement('div');
  win.id     = 'almac-chatbot-window';

  let headerLabel = 'Almac Sports — Expert Advice';
  if (PRODUCT)          headerLabel = PRODUCT;
  else if (isCollectionPage()) headerLabel = collectionName() + ' — Get Advice';

  win.innerHTML = `
    <div class="ac-header">
      <div class="ac-header-title">
        <span class="ac-header-dot"></span>
        <span class="ac-header-text">${headerLabel}</span>
      </div>
      <span class="ac-close">×</span>
    </div>
    <div class="ac-body" id="ac-body"></div>
    <div class="ac-footer">
      <input type="text"  id="ac-input"  placeholder="Type your message…" style="display:none">
      <button             id="ac-send">Send</button>
    </div>`;
  document.body.appendChild(win);

  const body   = document.getElementById('ac-body');
  const input  = document.getElementById('ac-input');
  const send   = document.getElementById('ac-send');
  const close  = win.querySelector('.ac-close');

  /* ============================================================
     PROACTIVE MESSAGE
     ============================================================ */
  (function initProactive() {
    if (localStorage.getItem('almac_proactive_closed') === 'yes') return;

    let msg = '';
    let delay = 3000;

    if (PRODUCT) {
      msg   = `<span id="almac-proactive-close">×</span>🔥 <strong>Best Price Alert:</strong> Get a special deal on the ${PRODUCT} today!`;
      delay = 1500;
    } else if (isCollectionPage()) {
      msg   = `<span id="almac-proactive-close">×</span>🔍 Looking for <strong>${collectionName()}</strong>? Tap for our top pick.`;
      delay = 2000;
    } else {
      msg   = `<span id="almac-proactive-close">×</span>💬 Have a question? Chat with us — get <strong>25–40% OFF</strong>!`;
    }

    setTimeout(() => {
      proactive.innerHTML = msg;
      proactive.classList.add('show');

      // Auto-hide after 25s (only if user hasn't manually closed)
      setTimeout(() => proactive.classList.remove('show'), 25000);
    }, delay);
  })();

  document.addEventListener('click', e => {
    if (e.target.id === 'almac-proactive-close') {
      proactive.classList.remove('show');
      localStorage.setItem('almac_proactive_closed', 'yes');
    }
  });

  /* ============================================================
     TYPING + BUBBLE HELPERS
     ============================================================ */
  function typeBot(html, buttons = [], cb) {
    // Show typing dots
    const typing = document.createElement('div');
    typing.className = 'ac-typing';
    typing.innerHTML = '<span class="ac-dot"></span><span class="ac-dot"></span><span class="ac-dot"></span>';
    body.appendChild(typing);
    scrollBottom();

    setTimeout(() => {
      typing.remove();

      const bubble = document.createElement('div');
      bubble.className = 'ac-bot';
      bubble.innerHTML = html;
      body.appendChild(bubble);

      if (buttons.length) {
        const wrap = document.createElement('div');
        wrap.className = 'ac-buttons';
        buttons.forEach(({ label, primary }) => {
          const b = document.createElement('button');
          b.className = 'ac-btn' + (primary ? ' ac-btn-primary' : '');
          b.innerText = label;
          wrap.appendChild(b);
        });
        body.appendChild(wrap);
      }

      scrollBottom();
      if (cb) cb();
    }, 520);
  }

  function btn(label, primary = false) { return { label, primary }; }

  function addUser(msg) {
    const u = document.createElement('div');
    u.className = 'ac-user';
    u.innerText = msg;
    body.appendChild(u);
    scrollBottom();
  }

  function scrollBottom() {
    body.scrollTop = body.scrollHeight;
  }

  function clearButtons() {
    body.querySelectorAll('.ac-buttons').forEach(el => el.remove());
  }

  function showInput() {
    input.style.display = 'block';
    input.focus();
  }
  function hideInput() {
    input.style.display = 'none';
    input.value = '';
  }

  /* ============================================================
     LEAD SUBMISSION — 2-STEP INTENTIONAL CAPTURE
     Phone submitted → Step 1 send (catches drop-offs)
     Name submitted  → Step 2 send (enriches record)
     ============================================================ */
  function sendLead(step1 = false) {
    fetch(WEBHOOK, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Name:             step1 ? '(Not provided yet)' : lead.name,
        Phone:            lead.phone,
        Purpose:          lead.purpose,
        Product:         lead.category,
        Budget:           lead.budget || '',
        Lead_Source:      utm.source,
        Lead_Medium:      utm.medium,
        Lead_Campaign:    utm.campaign,
        Step:             step1 ? 'Phone Only' : 'Complete',
        Date:             new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
      }),
    }).catch(() => {});
  }

  /* ============================================================
     WHATSAPP OPENER
     ============================================================ */
  function openWhatsApp(customMsg) {
    const base = 'https://wa.me/919833933681?text=';
    const msg  = customMsg || (
      lead.purpose === 'Service'
        ? `Hi! I need service support for my ${lead.category || 'fitness equipment'}. Please help.`
        : PRODUCT
          ? `Hi! I'm interested in the ${PRODUCT}. Please share the best price.`
          : `Hi! I'm interested in a ${lead.category || 'fitness equipment'}. Please share options and pricing.`
    );
    window.open(base + encodeURIComponent(msg), '_blank');
  }

  /* ============================================================
     CONVERSATION FLOWS
     ============================================================ */

  // Root: product page
  function startProductPage() {
    typeBot(
      `🔥 <strong>${PRODUCT}</strong> — great choice! How can we help you today?`,
      [
        btn('💰 Get Best Price', true),
        btn('📋 Ask about Specs'),
        btn('❓ What is iFIT?'),
        btn('🔧 Service / Support'),
      ]
    );
    step = 'product_root';
  }

  // Root: non-product page
  function startGeneral() {
    typeBot(
      'Hey! 👋 Welcome to Almac Sports. How can we help you today?',
      [btn('🛍️ Buy Equipment', true), btn('🔧 Service / Support')]
    );
    step = 'general_root';
  }

  // Purchase → category selection
  function askCategory() {
    typeBot('Which equipment are you looking for?', [
      btn('🏃 Treadmill'),
      btn('🚴 Exercise Bike'),
      btn('🔄 Elliptical'),
      btn('🚣 Rowing Machine'),
      btn('🤔 Suggest me the best'),
    ]);
    step = 'ask_category';
  }

  // Category selected → offer contact immediately
  function categorySelected(cat) {
    lead.category = cat;
    lead.purpose  = 'Purchase';
    typeBot(
      `Great choice! Our experts can share the best price and details for a <strong>${cat}</strong> right now.`,
      [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
    );
    step = 'ask_contact';
  }

  // "Suggest me best" → ask budget
  function askBudget(cat) {
    lead.category = cat;
    lead.purpose  = 'Purchase';
    typeBot('What is your budget range?', [
      btn('₹1L – ₹2L'),
      btn('₹2L – ₹3.5L'),
      btn('₹3.5L+'),
    ]);
    step = 'ask_budget';
  }

  // Show recommendation, then offer contact
  function showRecommendation(budget) {
    lead.budget = budget;
    const reco  = RECO[lead.category]?.[budget];

    if (reco) {
      typeBot(
        `For a <strong>${lead.category}</strong> in the <strong>${budget}</strong> range, we recommend:<br><br>` +
        `🏆 <strong>${reco.model}</strong><br>${reco.note}`,
        [btn('💬 Get Price on WhatsApp', true), btn('📞 Call Me to Discuss')]
      );
    } else {
      typeBot(
        `We have great options in the <strong>${budget}</strong> range for <strong>${lead.category}</strong>! Let our expert help you pick.`,
        [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
      );
    }
    step = 'ask_contact';
  }

  // Service → which equipment
  function askServiceEquipment() {
    lead.purpose = 'Service';
    typeBot('Sure! Which equipment needs servicing?', [
      btn('🏃 Treadmill'),
      btn('🚴 Exercise Bike'),
      btn('🔄 Elliptical'),
      btn('🚣 Rowing Machine'),
    ]);
    step = 'ask_service_equipment';
  }

  // Service equipment selected → contact
  function serviceEquipmentSelected(cat) {
    lead.category = cat;
    typeBot(
      `Got it — we'll arrange a service visit for your <strong>${cat}</strong>. How would you like to connect?`,
      [btn('💬 WhatsApp for Service', true), btn('📞 Get a Callback')]
    );
    step = 'ask_contact';
  }

  // iFIT objection path
  function explainIFIT() {
    typeBot(
      `<strong>iFIT</strong> is NordicTrack's interactive training platform — think of it as Netflix for workouts.<br><br>` +
      `✅ Real trainers lead sessions filmed around the world<br>` +
      `✅ The machine auto-adjusts your speed, incline & resistance as you train<br>` +
      `Subscription is optional — the equipment works fine without an active subscription too. With the subscription you get to visit the whole world while working out.`,
      [btn('💰 Get Best Price Now', true), btn('💬 Still have questions')]
    );
    step = 'ifit_explained';
  }

  // Callback: ask phone
  function askPhone() {
    typeBot('📞 Please enter your 10-digit mobile number:');
    showInput();
    step = 'ask_phone';
  }

  // Phone received → ask name
  function phoneReceived(phone) {
    lead.phone = phone;
    sendLead(true); // STEP 1 CAPTURE — saves even if they drop after this
    typeBot('👤 May I know your name?');
    step = 'ask_name';
  }

  // Name received → done
  function nameReceived(name) {
    lead.name = name;
    hideInput();
    sendLead(false); // STEP 2 CAPTURE — enriches with name
    typeBot(`✅ Thanks, <strong>${name}</strong>! Our team will call you shortly with the best offer. 🎯`);
    step = 'done';
  }

  /* ============================================================
     MAIN MESSAGE HANDLER
     ============================================================ */
  function handle(msg) {
    chatEngaged = true; // block exit popup from firing once engaged
    addUser(msg);
    clearButtons();

    // — Phone input step —
    if (step === 'ask_phone') {
      const cleaned = msg.replace(/\D/g, '');
      if (cleaned.length === 10) {
        phoneReceived(cleaned);
      } else {
        typeBot('❗ Please enter a valid 10-digit number (digits only):');
      }
      return;
    }

    // — Name input step —
    if (step === 'ask_name') {
      if (msg.trim().length > 1) {
        nameReceived(msg.trim());
      } else {
        typeBot('Please enter your full name:');
      }
      return;
    }

    // — Product page root —
    if (step === 'product_root') {
      if (msg.includes('Get Best Price')) {
        lead.purpose  = 'Purchase';
        lead.category = PRODUCT;
        typeBot(
          `💰 Let's get you the best price on the <strong>${PRODUCT}</strong> right now.`,
          [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
        );
        step = 'ask_contact';
      } else if (msg.includes('Ask about Specs')) {
        lead.purpose  = 'Purchase';
        lead.category = PRODUCT;
        const specs = getSpecs(PRODUCT);
        if (specs) {
          const rows = Object.entries(specs)
            .map(([k, v]) => `<strong>${k.charAt(0).toUpperCase() + k.slice(1)}:</strong> ${v}`)
            .join('<br>');
          typeBot(
            `Here are the key specs for the <strong>${PRODUCT}</strong>:<br><br>${rows}`,
            [btn('💰 Get Best Price', true), btn('🔄 Compare Models'), btn('💬 Ask More on WhatsApp')]
          );
          step = 'post_specs';
        } else {
          typeBot(
            `Our expert can walk you through the full specs and compare models for you.`,
            [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
          );
          step = 'ask_contact';
        }
      } else if (msg.includes('iFIT')) {
        explainIFIT();
      } else if (msg.includes('Service')) {
        lead.category = PRODUCT;
        serviceEquipmentSelected(PRODUCT);
      }
      return;
    }

    // — Post specs followup —
    if (step === 'post_specs') {
      if (msg.includes('Compare')) {
        typeBot(
          `Great idea! Our experts can run a side-by-side comparison based on your usage and budget.`,
          [btn('💬 Compare on WhatsApp', true), btn('📞 Call Me to Compare')]
        );
        step = 'ask_contact';
      } else if (msg.includes('WhatsApp') || msg.includes('Ask More')) {
        openWhatsApp(`Hi! I'd like to know more about the specs of the ${PRODUCT}. Can you help?`);
        typeBot('✅ WhatsApp opened! Ask our expert anything about the specs or alternatives.');
        step = 'done';
      } else if (msg.includes('Price')) {
        typeBot(
          `Let's get you the best price on the <strong>${PRODUCT}</strong>.`,
          [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
        );
        step = 'ask_contact';
      }
      return;
    }

    // — iFIT explained followup —
    if (step === 'ifit_explained') {
      if (msg.includes('questions')) {
        lead.purpose  = 'Purchase';
        lead.category = PRODUCT || 'Equipment';
        openWhatsApp(`Hi! I have some questions about iFIT on the ${PRODUCT || 'NordicTrack equipment'}. Can you help?`);
        typeBot('✅ WhatsApp opened! Our team will answer all your iFIT questions.');
        step = 'done';
      } else {
        lead.purpose  = 'Purchase';
        lead.category = PRODUCT || 'Equipment';
        typeBot(
          `Let's get you the best price on the <strong>${PRODUCT || 'equipment'}</strong>.`,
          [btn('💬 Chat on WhatsApp', true), btn('📞 Get a Callback')]
        );
        step = 'ask_contact';
      }
      return;
    }

    // — General root —
    if (step === 'general_root') {
      if (/buy|purchase|equipment/i.test(msg)) {
        askCategory();
      } else if (/service|support/i.test(msg)) {
        askServiceEquipment();
      }
      return;
    }

    // — Category selection —
    if (step === 'ask_category') {
      if (/suggest|best|not sure/i.test(msg)) {
        typeBot('Which type of equipment are you considering?', [
          btn('🏃 Treadmill'),
          btn('🚴 Exercise Bike'),
          btn('🔄 Elliptical'),
          btn('🚣 Rowing Machine'),
        ]);
        step = 'ask_suggest_category';
      } else {
        const cat = msg.replace(/^[^\w]+/, '').trim(); // strip emoji prefix
        categorySelected(cat);
      }
      return;
    }

    // — Suggest: category —
    if (step === 'ask_suggest_category') {
      const cat = msg.replace(/^[^\w]+/, '').trim();
      askBudget(cat);
      return;
    }

    // — Budget selection —
    if (step === 'ask_budget') {
      showRecommendation(msg);
      return;
    }

    // — Service equipment —
    if (step === 'ask_service_equipment') {
      const cat = msg.replace(/^[^\w]+/, '').trim();
      serviceEquipmentSelected(cat);
      return;
    }

    // — Contact choice —
    if (step === 'ask_contact') {
      if (/whatsapp/i.test(msg)) {
        openWhatsApp();
        typeBot('✅ WhatsApp opened! Our team replies within minutes. 🚀');
        step = 'done';
      } else if (/call|callback/i.test(msg)) {
        askPhone();
      }
      return;
    }
  }

  /* ============================================================
     START
     ============================================================ */
  function start() {
    if (PRODUCT) startProductPage();
    else startGeneral();
  }

  /* ============================================================
     EVENT LISTENERS
     ============================================================ */
  body.addEventListener('click', e => {
    if (e.target.classList.contains('ac-btn')) handle(e.target.innerText);
  });

  send.addEventListener('click', () => {
    const v = input.value.trim();
    if (v) { handle(v); input.value = ''; }
  });

  input.addEventListener('keypress', e => {
    if (e.key === 'Enter') {
      const v = input.value.trim();
      if (v) { handle(v); input.value = ''; }
    }
  });

  launcher.addEventListener('click', () => {
    win.style.display = 'flex';
    proactive.classList.remove('show');
    launcher.querySelector('.ac-badge').style.display = 'none';
    if (!chatOpened) { chatOpened = true; start(); }
  });

  close.addEventListener('click', () => {
    win.style.display = 'none';
  });

  proactive.addEventListener('click', e => {
    if (e.target.id !== 'almac-proactive-close') launcher.click();
  });

  // Expose engagement flag for exit popup
  window.almacChatEngaged = () => chatEngaged;

})();


/* ============================================================
   EXIT POPUP
   ============================================================ */
(function () {
  const MASTER_IMAGE = 'https://cdn.shopify.com/s/files/1/0633/6371/1135/files/NordicTrack_2450_Treadmill_X24_Spin_Bike_X24_Elliptical_and_RW900_Rower.png?v=1765783539';
  const WEBHOOK      = 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTZiMDYzMzA0Mzc1MjY0NTUzZDUxMzEi_pc';
  const isMobile     = window.innerWidth <= 768;

  // Preload image
  const preload  = document.createElement('link');
  preload.rel    = 'preload';
  preload.as     = 'image';
  preload.href   = MASTER_IMAGE;
  document.head.appendChild(preload);

  // Build overlay
  const overlay  = document.createElement('div');
  overlay.className = 'almac-popup-overlay';

  let pageCtx = document.title.split('–')[0].split('|')[0].trim();
  if (pageCtx.length > 50) pageCtx = 'this equipment';

  overlay.innerHTML = `
    <div class="almac-popup-container">
      <div class="almac-popup-image" style="background-image:url('${MASTER_IMAGE}');"></div>
      <div class="almac-popup-form">
        <div class="almac-popup-close">×</div>
        <div class="almac-popup-eyebrow">Exclusive Offer</div>
        <div class="almac-popup-title">${isMobile ? 'Still Interested?' : 'Wait — Special Price Inside'}</div>
        <div class="almac-popup-subtitle">
          We've unlocked a <strong>Price Drop</strong> on <em>${pageCtx}</em> exclusively for you.
          Leave your details and we'll send the discounted quote directly.
        </div>
        <div class="almac-form-group">
          <input type="text" class="almac-input" id="almac-name"  placeholder="Your Name">
        </div>
        <div class="almac-form-group">
          <input type="tel" class="almac-input" id="almac-phone" placeholder="Mobile Number (10 digits)">
        </div>
        <button class="almac-submit-btn" id="almac-submit">Unlock My Price Drop</button>
        <div class="almac-footer-text">Our team will contact you with the discounted quote within minutes.</div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const closeBtn   = overlay.querySelector('.almac-popup-close');
  const submitBtn  = overlay.querySelector('#almac-submit');
  const nameInput  = overlay.querySelector('#almac-name');
  const phoneInput = overlay.querySelector('#almac-phone');

  function showPopup() {
    // Don't show if user already signed up
    if (localStorage.getItem('almac_user_signed_up') === 'yes') return;
    // Don't show if already shown this session
    if (sessionStorage.getItem('almac_popup_shown_session')) return;
    // ✅ NEW: Don't show if user has engaged with the chatbot
    if (typeof window.almacChatEngaged === 'function' && window.almacChatEngaged()) return;

    overlay.style.display = 'flex';
    setTimeout(() => overlay.classList.add('visible'), 10);
    sessionStorage.setItem('almac_popup_shown_session', 'yes');
  }

  function closePopup() {
    overlay.classList.remove('visible');
    setTimeout(() => overlay.style.display = 'none', 400);
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });

  submitBtn.addEventListener('click', () => {
    const name  = nameInput.value.trim();
    const phone = phoneInput.value.replace(/\D/g, '');

    if (!name || phone.length < 10) {
      alert('Please enter a valid name and 10-digit phone number.');
      return;
    }

    submitBtn.textContent = 'Processing…';
    submitBtn.style.opacity = '0.75';

    fetch(WEBHOOK, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Name:    name,
        Phone:   phone,
        Purpose: `Exit Popup — ${pageCtx}`,
        Product: pageCtx,
        Source:  'Exit Popup',
        Date:    new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
      }),
    }).then(() => {
      submitBtn.textContent = '✅ Price Drop Unlocked!';
      submitBtn.style.background = '#27AE60';
      submitBtn.style.opacity = '1';
      localStorage.setItem('almac_user_signed_up', 'yes');
      setTimeout(closePopup, 1800);
    }).catch(() => {
      submitBtn.textContent = 'Try Again';
      submitBtn.style.opacity = '1';
    });
  });

  // Trigger 1: Exit intent (desktop)
  if (!isMobile) {
    document.addEventListener('mouseleave', e => {
      if (e.clientY < 0) showPopup();
    });
  }

  // Trigger 2: Time delay (30s) — desktop + mobile
  setTimeout(showPopup, 30000);

})();